import React, { useMemo } from 'react';
import { Grid2 } from "@mui/material";
import CardAdministrador from "../../../components/ui/materialui/cardAdministrador";
import { 
    PermMedia as PermMediaIcon, 
    AccountBalance as AccountBalanceIcon, 
    FileDownload, 
    Payment as PaymentIcon, 
    AddCard as AddCardIcon, 
    AttachMoney, 
    Folder as FolderIcon, 
    FolderOpen as FolderOpenIcon 
} from '@mui/icons-material';
import { usePermissions } from '../../../components/auth/ProtectedRoute';
import { TipoFuncionalidad } from '../../../utils/enums';

interface SecureLink {
    to: string;
    icon: JSX.Element; 
    text: string;
    permissions: TipoFuncionalidad[]; 
}

const RecaudacionMasiva: React.FC = () => {
    const { hasPermission } = usePermissions();

    const filterLinks = (links: SecureLink[]) => 
        links.filter(link => link.permissions.some(perm => hasPermission(perm)));    

    const pacLinks = useMemo(() => filterLinks([
        { 
            to: "/recaudacionMasiva/administrarPac", 
            icon: <AccountBalanceIcon sx={{ fontSize: 22, color: "#ACD35E" }} />, 
            text: "Administrador PAC", 
            permissions: [TipoFuncionalidad.Recaudacion_adm, TipoFuncionalidad.Recaudacion_ver] 
        },
        { 
            to: "/recaudacionMasiva/archivoPac", 
            icon: <FileDownload sx={{ fontSize: 22, color: "#ACD35E" }} />, 
            text: "Archivo PAC", 
            permissions: [TipoFuncionalidad.Recaudacion_adm] 
        },
    ]), [hasPermission]);

    const patLinks = useMemo(() => filterLinks([
        { 
            to: "/recaudacionMasiva/administrarPat", 
            icon: <PaymentIcon sx={{ fontSize: 22, color: "#ACD35E" }} />, 
            text: "Administrador PAT", 
            permissions: [TipoFuncionalidad.Recaudacion_adm, TipoFuncionalidad.Recaudacion_ver] 
        },
        { 
            to: "/recaudacionMasiva/archivoPat", 
            icon: <FileDownload sx={{ fontSize: 22, color: "#ACD35E" }} />, 
            text: "Archivo PAT", 
            permissions: [TipoFuncionalidad.Recaudacion_adm] 
        },
    ]), [hasPermission]);

    const ocmLinks = useMemo(() => filterLinks([
        { 
            to: "/recaudacionMasiva/consultarOCM", 
            icon: <AttachMoney sx={{ fontSize: 22, color: "#17c2e6" }} />, 
            text: "Consulta y envío OCM", 
            permissions: [TipoFuncionalidad.Recaudacion_adm] 
        },
    ]), [hasPermission]);

    const registrarLinks = useMemo(() => filterLinks([
        { 
            to: "/recaudacionMasiva/registrarRecaudacion", 
            icon: <FolderOpenIcon sx={{ fontSize: 22, color: "#17c2e6" }} />, 
            text: "Registrar recaudación", 
            permissions: [TipoFuncionalidad.Recaudacion_adm] 
        },
    ]), [hasPermission]);

    return (
        <div>
            <Grid2 container spacing={2} sx={{ mt: 2 }}>
                
                {ocmLinks.length > 0 && (
                    <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
                        <CardAdministrador
                            title="OCM"
                            icon={<AttachMoney sx={{ fontSize: 20, color: "white" }} />}
                            links={ocmLinks}
                            backgroundColor="#17c2e6"
                            linkTextColor="text-info"
                        />
                    </Grid2>
                )}

                {pacLinks.length > 0 && (
                    <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
                        <CardAdministrador
                            title="PAC"
                            icon={<PermMediaIcon sx={{ fontSize: 20, color: "white" }} />}
                            links={pacLinks}
                            backgroundColor="#ACD35E"
                            linkTextColor="text-info"
                        />
                    </Grid2>
                )}

                {patLinks.length > 0 && (
                    <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
                        <CardAdministrador
                            title="PAT"
                            icon={<AddCardIcon sx={{ fontSize: 20, color: "white" }} />}
                            links={patLinks}
                            backgroundColor="#ACD35E"
                            linkTextColor="text-info"
                        />
                    </Grid2>
                )}

                {registrarLinks.length > 0 && (
                    <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
                        <CardAdministrador
                            title="Registrar recaudación masiva"
                            icon={<FolderIcon sx={{ fontSize: 20, color: "white" }} />}
                            links={registrarLinks}
                            backgroundColor="#17c2e6"
                            linkTextColor="text-info"
                        />
                    </Grid2>
                )}

            </Grid2 >
        </div>
    )
}

export default RecaudacionMasiva;